import { useNavigate } from "react-router-dom";
import { useProjects } from "../features/projects/hooks/useProjects";

import ProjectList from "../features/projects/components/ProjectList.jsx";
import Loading from "../features/uiStatus/components/Loading.jsx";
import Alert from '../components/Alert';
import { pageShell } from "../styles/pageShell";
import { typeShell } from "../styles/typeShell";

const EmptyState = () => (
    <div className="mx-auto flex w-full max-w-lg flex-col items-center p-card text-center">
        <h2 className={`${pageShell.sectionTitle} mb-3 justify-center text-center`}>
            プロジェクトがありません
        </h2>
        <p className={`m-0 max-w-full leading-relaxed ${typeShell.hint}`}>
            管理者に連絡してください。
        </p>
    </div>
);

const ProjectSelectionPage = () => {
    const { projects, loading, error } = useProjects();
    const navigate = useNavigate();
    const handleProjectClick = (project) => {
        try {
            navigate(`/dashboard/${project.id}/map`);
        } catch (navigationError) {
            console.error('Navigation failed:', navigationError);
        }
    };

    return (
        <div className={pageShell.containerAuto}>
            <div className={pageShell.header}>
                <h2 className={`${pageShell.title} w-full justify-center text-center`}>
                    プロジェクト選択
                </h2>
            </div>

            {error ? (
                <Alert type="danger" message={error.message || 'エラーが発生しました'} />
            ) : (
                <Loading
                    isLoading={loading}
                    message="読み込み中..."
                >
                    {projects.length === 0 ? (
                        <EmptyState />
                    ) : (
                        <div className="w-full">
                            <ProjectList
                                projects={projects}
                                onProjectClick={handleProjectClick}
                            />
                        </div>
                    )}
                </Loading>
            )}
        </div>
    );
};

export default ProjectSelectionPage;
